export interface PropertyFormData {
  // Required fields
  name: string;
  address: string;
  property_type: string;

  // Location fields
  city: string;
  state: string;
  zip_code: string;
  country: string;
  latitude: string;
  longitude: string;

  // Details
  property_sub_type: string;
  property_description: string;
  square_footage: string;
  year_built: string;
  number_of_units: string;
  total_area: string;
}

export const PROPERTY_TYPES = {
  Commercial: [
    'Office Building',
    'Retail Space',
    'Warehouse',
    'Industrial',
    'Mixed Use',
    'Other',
  ],
  Residential: [
    'Single Family Home',
    'Condominium',
    'Townhouse',
    'Apartment Building',
    'Duplex/Triplex',
    'Mobile Home',
    'Other',
  ],
} as const;

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming',
];

export const INITIAL_FORM_DATA: PropertyFormData = {
  name: '',
  address: '',
  property_type: '',
  city: '',
  state: '',
  zip_code: '',
  country: 'United States',
  latitude: '',
  longitude: '',
  property_sub_type: '',
  property_description: '',
  square_footage: '',
  year_built: '',
  number_of_units: '',
  total_area: '',
};
